// extracted by mini-css-extract-plugin
module.exports = {"rootClassName":"private-container"};